/**
 * PrimeNG 20 preset approximating legacy `saga-orange` (PrimeNG ≤17) colors and typography tokens.
 * Source reference: `common/app/themes/saga-orange/theme.css` :root (--primary-color, surfaces, etc.)
 */
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const sagaPrimaryScale = {
	50: '#fff8e1',
	100: '#ffecb3',
	200: '#ffe082',
	300: '#ffd54f',
	400: '#ffca28',
	500: '#FFC107',
	600: '#ffb300',
	700: '#ffa000',
	800: '#ff8f00',
	900: '#ff6f00',
	950: '#e65100',
} as const;

export const sagaOrangePreset = definePreset(Lara, {
	semantic: {
		primary: { ...sagaPrimaryScale },
		colorScheme: {
			light: {
				primary: {
					color: '{primary.500}',
					contrastColor: '#212529',
					hoverColor: '{primary.600}',
					activeColor: '{primary.700}',
				},
				highlight: {
					background: '#FFF3E0',
					focusBackground: '#FFE0B2',
					color: '#495057',
					focusColor: '#495057',
				},
				focusRing: {
					width: '0',
					style: 'none',
					color: 'transparent',
					offset: '0',
					shadow: '0 0 0 0.2rem #ffe69c',
				},
				text: {
					color: '#495057',
					hoverColor: '#212529',
					mutedColor: '#6c757d',
					hoverMutedColor: '#495057',
				},
				content: {
					background: '#ffffff',
					hoverBackground: '#f8f9fa',
					borderColor: '#dee2e6',
				},
				surface: {
					0: '#ffffff',
					50: '#fafafa',
					100: '#f5f5f5',
					200: '#eeeeee',
					300: '#e0e0e0',
					400: '#bdbdbd',
					500: '#9e9e9e',
					600: '#757575',
					700: '#616161',
					800: '#424242',
					900: '#212121',
					950: '#121212',
				},
			},
		},
	},
});

export const sagaOrangePrimeNGTheme = {
	preset: sagaOrangePreset,
	options: {
		cssLayer: false,
		/** Default is `system`; OS dark mode switches Lara to dark surfaces. MAS stays legacy light saga-orange. */
		darkModeSelector: false,
	},
};
